import { selectors } from './config';

export default class Controls {
  buttonMapping = new Map();

  constructor(container) {
    this.container = container;

    this.nextButton = container.querySelector(selectors.nextButton);
    this.prevButton = container.querySelector(selectors.prevButton);
  }

  mapButtons() {
    this.buttonMapping.set(this.nextButton, this.kenectNext);
    this.buttonMapping.set(this.prevButton, this.kenectPrev);
  }

  attachListeners() {
    this.buttonMapping.forEach((kenectButton, control) => {
      control.addEventListener('click', (event) => {
        event.preventDefault();
        kenectButton.click();
      });
    });
  }

  get isMounted() {
    return this.container.dataset.mounted === 'true';
  }

  set isMounted(updatedState) {
    this.container.dataset.mounted = updatedState;
  }

  mount(kenectSliderEl) {
    this.kenectNext = kenectSliderEl.querySelector(selectors.kenectNext);
    this.kenectPrev = kenectSliderEl.querySelector(selectors.kenectPrev);

    this.mapButtons();
    this.attachListeners();
    this.container.setAttribute('aria-controls', kenectSliderEl.id);
    this.isMounted = true;
  }
}
